(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bh-ceramel-studie"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){if(root.dataset.csReady)return;root.dataset.csReady='true';const config=JSON.parse(root.querySelector('[data-cs-config]').textContent);
const metrics=config.metrics;
root.querySelectorAll('[data-metric]').forEach(button=>button.addEventListener('click',()=>{const m=metrics[button.dataset.metric];root.querySelectorAll('[data-metric]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});for(const [id,value] of Object.entries({'chart-tool':m.tool,'chart-title':m.title,'chart-description':m.description,'before-value':m.labels[0],'after-value':m.labels[1],'chart-note':m.note})){root.querySelector('[data-cs-role="'+id+'"]').textContent=value}const max=Math.max(m.before,m.after)/.8;root.querySelector('[data-cs-role="before-bar"]').style.width=(m.before/max*100)+'%';root.querySelector('[data-cs-role="after-bar"]').style.width=(m.after/max*100)+'%';root.querySelector('[data-cs-role="chart-count"]').innerHTML='<b>'+m.count+' '+config.of_twenty+'</b><br>'+config.improvement;root.querySelector('[data-cs-role="chart-source"]').href=config.report.split('#')[0]+'#page=2';}));
const photos={redness:{src:config.redness,alt:config.redness_alt,title:config.redness_title,description:config.redness_description},texture:{src:config.texture,alt:config.texture_alt,title:config.texture_title,description:config.texture_description}};
root.querySelectorAll('[data-image]').forEach(button=>button.addEventListener('click',()=>{const p=photos[button.dataset.image];root.querySelectorAll('[data-image]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active))});const img=root.querySelector('[data-cs-role="study-image"]');img.src=p.src;img.alt=p.alt;img.title=p.title;root.querySelector('[data-cs-role="image-description"]').textContent=p.description;}));
}document.querySelectorAll('.bh-ceramel').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.bh-ceramel').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-editable-article"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh-article-guide')) {
  customElements.define('bh-article-guide', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const toc = this.querySelector('[data-guide-toc]');
      this.compact = window.innerWidth < 900;
      if (toc) toc.open = !this.compact;
      this.addEventListener('click', (event) => {
        const link = event.target.closest('[data-guide-link],a[href^="#bh-guide-"]');
        if (!link) return;
        const target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        if (toc && window.innerWidth < 900) toc.open = false;
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, options);
      window.addEventListener('resize', () => {
        const compact = window.innerWidth < 900;
        if (toc && compact !== this.compact) toc.open = !compact;
        this.compact = compact;
      }, options);
      const headings = [...this.querySelectorAll('[data-guide-heading]')];
      const links = [...this.querySelectorAll('[data-guide-link]')];
      const update = () => {
        let current = 0;
        headings.forEach((heading, index) => {
          if (heading.getBoundingClientRect().top < 220) current = index;
        });
        links.forEach((link, index) => {
          link.classList.toggle('is-active', index === current);
          if (index === current) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        this.pending = false;
      };
      window.addEventListener('scroll', () => {
        if (this.pending) return;
        this.pending = true;
        requestAnimationFrame(update);
      }, { passive: true, signal: this.controller.signal });
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-knowledge-hub"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bh-knowledge-hub')) {
  customElements.define('bh-knowledge-hub', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-hub-config]').textContent);
      this.config.root = this.config.root.replace(/\/?$/, '/');
      this.links = [...this.querySelectorAll('[data-topic]')];
      this.list = this.querySelector('[data-hub-list]');
      this.count = this.querySelector('[data-hub-count]');
      this.pager = this.querySelector('[data-hub-pagination]');
      this.error = this.querySelector('[data-hub-error]');
      this.overrides = new Map(this.config.overrides.map(item => [item.id, item]));
      this.pages = new Map();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-topic], [data-hub-page]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const url = new URL(location.href);
        if (link.dataset.topic) {
          url.searchParams.delete('bh_page');
          url.hash = link.hash;
        } else {
          url.searchParams.set('bh_page', link.dataset.hubPage);
        }
        history.pushState(null, '', url);
        this.applyURL(true);
      }, options);
      this.querySelector('[data-hub-retry]').addEventListener('click', () => this.applyURL(false), options);
      window.addEventListener('hashchange', () => this.applyURL(false), options);
      window.addEventListener('popstate', () => this.applyURL(false), options);
      document.addEventListener('click', event => {
        const link = event.target.closest('a[href]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = new URL(link.href, location.href);
        if (target.origin === location.origin && target.pathname === location.pathname && this.links.some(item => item.hash === target.hash) && document.body.classList.contains('reveal-mobile-nav')) {
          document.querySelector('.navigation__mobile-header .mobile-nav-toggle')?.click();
        }
      }, options);
      const topic = this.currentTopic();
      if (topic !== 'all' || this.currentPage() > 1) this.applyURL(false);
    }
    disconnectedCallback() { this.controller?.abort(); }
    currentTopic() { return (this.links.find(link => link.hash === location.hash) || this.links[0]).dataset.topic; }
    currentPage() { return Math.max(1, Math.min(2500, Number.parseInt(new URL(location.href).searchParams.get('bh_page'), 10) || 1)); }
    async api(query, variables) {
      const response = await fetch('/api/2026-10/graphql.json', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({query,variables}),signal:this.controller.signal});
      const result = await response.json();
      if (!response.ok || result.errors || !result.data) throw new Error('Article request failed');
      return result.data;
    }
    fields() { return 'id title handle publishedAt excerpt(truncateAt: 500) image {url altText width height} blog {handle title} authorV2 {name}'; }
    searchQuery(topic) {
      const quote = value => `"${value.replaceAll('\\','\\\\').replaceAll('"','\\"')}"`;
      const blogs = this.config.blogs.map(title => `blog_title:${quote(title)}`).join(' OR ');
      let filter = '';
      if (topic === 'allgemein') filter = Object.values(this.config.tags).flat().map(tag => `tag_not:${quote(tag)}`).join(' AND ');
      else if (topic !== 'all') filter = `(${this.config.tags[topic].map(tag => `tag:${quote(tag)}`).join(' OR ')})`;
      return `(${blogs})${filter ? ` AND ${filter}` : ''}`;
    }
    async buildPage(topic, start) {
      const state = {...start};
      const fixed = topic === 'all' ? [] : this.config.overrides.filter(item => item.topic === topic || (topic === 'selbermachen' && item.alsoDiy)).sort((a,b) => Date.parse(b.date)-Date.parse(a.date) || b.id.localeCompare(a.id));
      const selected = [];
      let buffer = [], more = true;
      const peek = async () => {
        while (true) {
          if (!buffer.length && more) {
            const data = await this.api(`query HubArticles($first: Int!, $after: String, $query: String!) { articles(first: $first, after: $after, query: $query, sortKey: PUBLISHED_AT, reverse: true) { edges {cursor node {${this.fields()}}} pageInfo {hasNextPage endCursor} } }`, {first:this.config.pageSize+1,after:state.cursor,query:this.searchQuery(topic)});
            buffer = data.articles.edges;
            more = data.articles.pageInfo.hasNextPage;
          }
          if (!buffer.length) return null;
          if (topic !== 'all' && this.overrides.has(buffer[0].node.id)) { state.cursor=buffer.shift().cursor; continue; }
          return buffer[0];
        }
      };
      while (selected.length < this.config.pageSize) {
        const edge = await peek(), item = fixed[state.fixedOffset];
        if (!edge && !item) break;
        if (item && (!edge || Date.parse(item.date) >= Date.parse(edge.node.publishedAt))) {
          selected.push({id:item.id,fixed:true}); state.fixedOffset++;
        } else { selected.push(edge.node);state.cursor=buffer.shift().cursor; }
      }
      const hasNext = Boolean(fixed[state.fixedOffset] || await peek());
      const ids = selected.filter(item => item.fixed).map(item => item.id);
      if (ids.length) {
        const data = await this.api(`query HubSelected($ids: [ID!]!) {nodes(ids:$ids) {... on Article {${this.fields()}}}}`, {ids});
        const nodes = new Map(data.nodes.filter(Boolean).map(item => [item.id,item]));
        selected.forEach((item,index) => {if(item.fixed) selected[index]=nodes.get(item.id);});
      }
      return {items:selected.filter(Boolean),next:{cursor:state.cursor,fixedOffset:state.fixedOffset},hasNext};
    }
    async page(topic, number) {
      if (!this.pages.has(topic)) this.pages.set(topic,new Map());
      const cache = this.pages.get(topic);
      if (cache.has(number)) return cache.get(number);
      let start = {cursor:null,fixedOffset:0};
      for (let page=1;page<=number;page++) {
        const result = cache.get(page) || await this.buildPage(topic,start);
        cache.set(page,result);
        if (page === number || !result.hasNext) return {...result,number:page};
        start=result.next;
      }
    }
    escape(value) { return String(value || '').replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;').replaceAll('"','&quot;').replaceAll("'",'&#39;'); }
    imageURL(url, width) { const target=new URL(url);target.searchParams.set('width',width);target.searchParams.set('height',Math.round(width/this.config.ratio));target.searchParams.set('crop','center');return target.href; }
    card(item) {
      const e=value=>this.escape(value), override=this.overrides.get(item.id);
      const url=`${this.config.root}blogs/${encodeURIComponent(item.blog.handle)}/${encodeURIComponent(item.handle)}`;
      const image=item.image || this.config.fallbackImage;
      let media='';
      if(image) media=`<div class="article-image"><a href="${e(url)}" tabindex="-1" aria-hidden="true"><img src="${e(this.imageURL(image.url,640))}" srcset="${[320,480,640,880].map(width=>`${e(this.imageURL(image.url,width))} ${width}w`).join(', ')}" sizes="(min-width:1024px) 440px,(min-width:768px) 50vw,100vw" width="880" height="${Math.round(880/this.config.ratio)}" alt="${e(image.altText || item.title)}" loading="lazy" decoding="async"></a></div>`;
      const date=new Date(item.publishedAt).toLocaleDateString(this.config.locale,{day:'numeric',month:'long',year:'numeric'});
      const meta=[this.config.showDate ? `<time datetime="${e(item.publishedAt)}">${e(date)}</time>` : '',this.config.showAuthor ? `<span class="author">${e(item.authorV2?.name)}</span>` : ''].filter(Boolean).join(' — ');
      return `<article class="article"><div class="article__inner">${media}<div class="bh-knowledge-hub__body"><h2 class="h3"><a href="${e(url)}">${e(item.title)}</a></h2>${meta ? `<div class="meta meta--after-title small-text">${meta}</div>` : ''}<div class="rte"><p>${e(override?.summary || item.excerpt)}</p></div><div class="article__read-more-container"><a class="small-feature-link" href="${e(url)}" aria-label="${e(this.config.labels.readMore)}: ${e(item.title)}">${e(this.config.labels.readMore)} <span class="bh-knowledge-hub__arrow" aria-hidden="true">→</span></a></div></div></div></article>`;
    }
    pageLink(number, label, rel='') {
      const url=new URL(location.href);if(number===1) url.searchParams.delete('bh_page');else url.searchParams.set('bh_page',number);
      return `<a class="btn btn--secondary" href="${this.escape(url.pathname+url.search+url.hash)}" data-hub-page="${number}" ${rel ? `rel="${rel}"` : ''}>${this.escape(label)}</a>`;
    }
    async applyURL(scroll) {
      const run=this.run=(this.run || 0)+1,topic=this.currentTopic(),number=this.currentPage();
      this.setAttribute('aria-busy','true');this.error.hidden=true;
      try {
        const result=await this.page(topic,number);
        if(run!==this.run || !this.isConnected) return;
        const actual=result.number || number;
        this.list.innerHTML=result.items.map(item=>this.card(item)).join('');
        this.links.forEach(link=>{if(link.dataset.topic===topic)link.setAttribute('aria-current','true');else link.removeAttribute('aria-current');});
        const label=this.links.find(link=>link.dataset.topic===topic).textContent.trim();
        this.count.textContent=topic==='all' ? `${this.config.labels.total.replace('__COUNT__',this.config.total)} · ${this.config.labels.page.replace('__PAGE__',actual)}` : `${label} · ${this.config.labels.page.replace('__PAGE__',actual)}`;
        this.querySelector('[data-empty]').hidden=result.items.length>0;
        this.pager.innerHTML=(actual>1 ? this.pageLink(actual-1,this.config.labels.previous,'prev') : '')+`<span aria-current="page">${this.escape(this.config.labels.page.replace('__PAGE__',actual))}</span>`+(result.hasNext ? this.pageLink(actual+1,this.config.labels.next,'next') : '');
        this.pager.hidden=actual===1 && !result.hasNext;
        if(scroll) this.scrollIntoView({behavior:'instant',block:'start'});
      } catch(error) {if(error.name!=='AbortError' && run===this.run)this.error.hidden=false;}
      finally {if(run===this.run)this.removeAttribute('aria-busy');}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bh-universal-article"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bh-article]').forEach((article) => {
  const content = article.querySelector('[data-bh-content]');
  const toc = article.querySelector('[data-bh-toc]');
  if (!content) return;
  content.querySelectorAll('blockquote').forEach((callout) => {
    const label = callout.textContent.trim().toLocaleLowerCase('de');
    if (/\b(fazit|zusammenfassung|unser urteil|abschließende einordnung)\b/.test(label)) {
      callout.classList.add('bh-article__callout--final');
    } else if (/\b(das wichtigste|kurz erklärt|auf einen blick|schon gewusst)\b/.test(label)) {
      callout.classList.add('bh-article__callout--summary');
    }
  });
  let inFaq = false;
  Array.from(content.children).forEach((node) => {
    if (node.matches('h2')) {
      inFaq = /\b(faq|häufige fragen)\b/i.test(node.textContent);
      return;
    }
    if (!inFaq || !node.matches('h3') || !node.parentNode) return;
    const details = document.createElement('details');
    details.className = 'bh-article__faq';
    const summary = document.createElement('summary');
    const title = node.cloneNode(true);
    title.removeAttribute('id');
    summary.append(title);
    const answer = document.createElement('div');
    let next = node.nextElementSibling;
    while (next && !next.matches('h2,h3')) {
      const current = next;
      next = next.nextElementSibling;
      answer.append(current);
    }
    node.before(details);
    details.append(summary, answer);
    node.remove();
  });
  if (article.querySelector('[data-bh-related]')) {
    Array.from(content.querySelectorAll('h2')).forEach((heading) => {
      if (heading.textContent.trim().toLocaleLowerCase('de') !== 'passend dazu') return;
      let node = heading.nextSibling;
      while (node && !(node.nodeType === 1 && node.tagName === 'H2')) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      heading.remove();
    });
  }
  const headings = Array.from(content.querySelectorAll('h2'));
  headings.forEach((heading) => {
    const label = heading.textContent.trim().toLocaleLowerCase('de');
    if (/steckbrief|botanik|pflanze im überblick/.test(label)) heading.classList.add('bh-botanical__facts');
    if (/blütezeit|blühzeit|wann blüht/.test(label)) heading.classList.add('bh-botanical__bloom');
    if (/bienen|bestäuber|nektar|pollen|tracht/.test(label)) heading.classList.add('bh-botanical__bees');
  });
  if (!toc) return;
  if (headings.length < 3 && toc.dataset.mode !== 'show') return;
  const links = toc.querySelector('[data-bh-toc-links]');
  if (!links) return;
  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `bh-section-${index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    const number = document.createElement('span');
    number.textContent = String(index + 1).padStart(2, '0');
    link.append(number, document.createTextNode(heading.textContent.trim()));
    links.append(link);
  });
  toc.hidden = false;
  article.classList.add('bh-article--has-toc');
  if ('IntersectionObserver' in window) {
    const tocLinks = Array.from(links.querySelectorAll('a'));
    const byId = new Map(tocLinks.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));
    const observer = new IntersectionObserver((entries) => {
      entries.filter((entry) => entry.isIntersecting).forEach((entry) => {
        tocLinks.forEach((link) => link.classList.toggle('is-active', link === byId.get(entry.target.id)));
      });
    }, { rootMargin: '-18% 0px -70% 0px' });
    headings.forEach((heading) => observer.observe(heading));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
